<h1 mat-dialog-title>
  Bewerkingen
  <div class="close-button">
    <button mat-icon-button aria-label="Sluiten" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
</h1>
<div mat-dialog-content>
  <h4>Nieuwste - oudste</h4>
  <mat-divider></mat-divider>
  @for (edit of allEdits(); track edit) {
    <div>
      @for (change of edit.changes; track change) {
        <div>
          @if (change.field === 'addedUsers') {
            <div>
              <div class="edit-item">
                <div>
                  <p><b>Bewerker:</b></p>
                  <p><b>Actie:</b></p>
                  <p><b>Bewerking:</b></p>
                </div>
                <div class="action-list">
                  <p class="edit-info">
                    <span>{{ edit.editedByEmail }}</span>
                    <span>{{ edit.date.toDate() | date: 'short' }}</span>
                  </p>
                  <p>Personen toegevoegd</p>
                  @for (user of change.users; track user) {
                    <div>
                      <p>
                        <b>{{ user.title }}</b>
                      </p>
                    </div>
                  }
                </div>
              </div>
              <mat-divider></mat-divider>
            </div>
          }
          @if (change.field === 'createdRide') {
            <div>
              <div class="edit-item">
                <div>
                  <p><b>Bewerker:</b></p>
                  <p><b>Actie:</b></p>
                </div>
                <div class="action-list">
                  <p class="edit-info">
                    <span>{{ edit.editedByEmail }}</span>
                    <span>{{ edit.date.toDate() | date: 'short' }}</span>
                  </p>
                  <p>{{ change.text }}</p>
                </div>
              </div>
              <mat-divider></mat-divider>
            </div>
          }
          @if (change.field === 'copiedRide') {
            <div>
              <div class="edit-item">
                <div>
                  <p><b>Bewerker:</b></p>
                  <p><b>Actie:</b></p>
                </div>
                <div class="action-list">
                  <p class="edit-info">
                    <span>{{ edit.editedByEmail }}</span>
                    <span>{{ edit.date.toDate() | date: 'short' }}</span>
                  </p>
                  <p>{{ change.text }}</p>
                </div>
              </div>
              <mat-divider></mat-divider>
            </div>
          }
          @if (change.field === 'removedUsers') {
            <div>
              <div class="edit-item">
                <div>
                  <p><b>Bewerker:</b></p>
                  <p><b>Actie:</b></p>
                  <p><b>Bewerking:</b></p>
                </div>
                <div class="action-list">
                  <p class="edit-info">
                    <span>{{ edit.editedByEmail }}</span>
                    <span>{{ edit.date.toDate() | date: 'short' }}</span>
                  </p>
                  <p>Personen verwijderd</p>
                  @for (user of change.users; track user) {
                    <div>
                      <p>
                        <b>{{ user.title }}</b>
                      </p>
                    </div>
                  }
                </div>
              </div>
              <mat-divider></mat-divider>
            </div>
          }
          @if (change.field === 'changedUsers') {
            @for (user of Object.values(change.users); track user) {
              @if (user.before.to) {
                <div>
                  <div class="edit-item">
                    <div>
                      <p><b>Bewerker:</b></p>
                      <p><b>Actie:</b></p>
                      <p><b>Bewerking:</b></p>
                    </div>
                    <div class="action-list">
                      <p class="edit-info">
                        <span>{{ edit.editedByEmail }}</span>
                        <span>{{ edit.date.toDate() | date: 'short' }}</span>
                      </p>
                      <p>Bestemming</p>
                      <p>{{ typeof user.before.to === 'string' ? user.before.to : (user.before.to?.address ?? '') }}</p>
                      <span class="arrow-wrapper">
                        <mat-icon>arrow_downward</mat-icon>
                        <span class="arrow-text"> is nu</span>
                      </span>
                      <p>
                        <b>{{ typeof user.after.to === 'string' ? user.after.to : (user.after.to?.address ?? '') }}</b>
                      </p>
                    </div>
                  </div>
                  <mat-divider></mat-divider>
                </div>
              }
              @if (user.before.from) {
                <div>
                  <div class="edit-item">
                    <div>
                      <p><b>Bewerker:</b></p>
                      <p><b>Actie:</b></p>
                      <p><b>Bewerking:</b></p>
                    </div>
                    <div class="action-list">
                      <p class="edit-info">
                        <span>{{ edit.editedByEmail }}</span>
                        <span>{{ edit.date.toDate() | date: 'short' }}</span>
                      </p>
                      <p>Startpunt</p>
                      <p>{{ typeof user.before.from === 'string' ? user.before.from : (user.before.from?.address ?? '') }}</p>
                      <span class="arrow-wrapper">
                        <mat-icon>arrow_downward</mat-icon>
                        <span class="arrow-text"> is nu</span>
                      </span>
                      <p>
                        <b>{{ typeof user.after.from === 'string' ? user.after.from : (user.after.from?.address ?? '') }}</b>
                      </p>
                    </div>
                  </div>
                  <mat-divider></mat-divider>
                </div>
              }
            }
          }
          @if (change.field !== 'addedUsers' && change.field !== 'removedUsers') {
            <div>
              @if (change.field === 'comments') {
                <div>
                  <div class="edit-item">
                    <div>
                      <p><b>Bewerker:</b></p>
                      <p><b>Actie:</b></p>
                      <p><b>Bewerking:</b></p>
                    </div>
                    <div class="action-list">
                      <p class="edit-info">
                        <span>{{ edit.editedByEmail }}</span>
                        <span>{{ edit.date.toDate() | date: 'short' }}</span>
                      </p>
                      <p>Opmerking (Rit)</p>
                      <p>{{ change.from }}</p>
                      <span class="arrow-wrapper">
                        <mat-icon>arrow_downward</mat-icon>
                        <span class="arrow-text"> is nu</span>
                      </span>
                      <p>
                        <b>{{ change.to }}</b>
                      </p>
                    </div>
                  </div>
                  <mat-divider></mat-divider>
                </div>
              }
              @if (change.field === 'start') {
                <div>
                  <div class="edit-item">
                    <div>
                      <p><b>Bewerker:</b></p>
                      <p><b>Actie:</b></p>
                      <p><b>Bewerking:</b></p>
                    </div>
                    <div class="action-list">
                      <p class="edit-info">
                        <span>{{ edit.editedByEmail }}</span>
                        <span>{{ edit.date.toDate() | date: 'short' }}</span>
                      </p>
                      <p>Begindatum</p>
                      <p>{{ change.from.toDate() | date: 'medium' }}</p>
                      <span class="arrow-wrapper">
                        <mat-icon>arrow_downward</mat-icon>
                        <span class="arrow-text"> is nu</span>
                      </span>
                      <p>
                        <b>{{ change.to.toDate() | date: 'medium' }}</b>
                      </p>
                    </div>
                  </div>
                  <mat-divider></mat-divider>
                </div>
              }
              @if (change.field === 'end') {
                <div>
                  <div class="edit-item">
                    <div>
                      <p><b>Bewerker:</b></p>
                      <p><b>Actie:</b></p>
                      <p><b>Bewerking:</b></p>
                    </div>
                    <div class="action-list">
                      <p class="edit-info">
                        <span>{{ edit.editedByEmail }}</span>
                        <span>{{ edit.date.toDate() | date: 'short' }}</span>
                      </p>
                      <p>Einddatum</p>
                      <p>{{ change.from.toDate() | date: 'medium' }}</p>
                      <span class="arrow-wrapper">
                        <mat-icon>arrow_downward</mat-icon>
                        <span class="arrow-text"> is nu</span>
                      </span>
                      <p>
                        <b>{{ change.to.toDate() | date: 'medium' }}</b>
                      </p>
                    </div>
                  </div>
                  <mat-divider></mat-divider>
                </div>
              }
              @if (change.field === 'rideProduct') {
                <div>
                  <div class="edit-item">
                    <div>
                      <p><b>Bewerker:</b></p>
                      <p><b>Actie:</b></p>
                      <p><b>Bewerking:</b></p>
                    </div>
                    <div class="action-list">
                      <p class="edit-info">
                        <span>{{ edit.editedByEmail }}</span>
                        <span>{{ edit.date.toDate() | date: 'short' }}</span>
                      </p>
                      <p>Ritprijs</p>
                      <p>{{ change.from.name }} - {{ change.from.cost }} Credits</p>
                      <span class="arrow-wrapper">
                        <mat-icon>arrow_downward</mat-icon>
                        <span class="arrow-text"> is nu</span>
                      </span>
                      <p>
                        <b>{{ change.to.name }} - {{ change.to.cost }} Credits</b>
                      </p>
                    </div>
                  </div>
                  <mat-divider></mat-divider>
                </div>
              }
              @if (change.field === 'special') {
                <div>
                  <div class="edit-item">
                    <div>
                      <p><b>Bewerker:</b></p>
                      <p><b>Actie:</b></p>
                      <p><b>Bewerking:</b></p>
                    </div>
                    <div class="action-list">
                      <p class="edit-info">
                        <span>{{ edit.editedByEmail }}</span>
                        <span>{{ edit.date.toDate() | date: 'short' }}</span>
                      </p>
                      <p>Rittype</p>
                      <p>{{ change.from }}</p>
                      <span class="arrow-wrapper">
                        <mat-icon>arrow_downward</mat-icon>
                        <span class="arrow-text"> is nu</span>
                      </span>
                      <p>
                        <b>{{ change.to }}</b>
                      </p>
                    </div>
                  </div>
                  <mat-divider></mat-divider>
                </div>
              }
              @if (change.field === 'vehicleId') {
                <div>
                  <div class="edit-item">
                    <div>
                      <p><b>Bewerker:</b></p>
                      <p><b>Actie:</b></p>
                      <p><b>Bewerking:</b></p>
                    </div>
                    <div class="action-list">
                      <p class="edit-info">
                        <span>{{ edit.editedByEmail }}</span>
                        <span>{{ edit.date.toDate() | date: 'short' }}</span>
                      </p>
                      <p>Voertuig</p>
                      <p>{{ change.from }}</p>
                      <span class="arrow-wrapper">
                        <mat-icon>arrow_downward</mat-icon>
                        <span class="arrow-text"> is nu</span>
                      </span>
                      <p>
                        <b>{{ change.to }}</b>
                      </p>
                    </div>
                  </div>
                  <mat-divider></mat-divider>
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  }
</div>
@if (allEdits()?.length === 0) {
  <div>
    <p><i>Er zijn geen bewerkingen aanwezig</i></p>
  </div>
}
